<template>
  <v-pagina-de-apresentacao>
    <template v-slot:main-content>
      <div class="text-center accent--text text-h4 mt-n4">
        Bem-vindo de volta!
      </div>
      <v-card class="elevation-7 pa-8 mt-2" rounded="lg" color="accent">
        <div flat color="accent">
          <v-toolbar-title class="text-h5">Login</v-toolbar-title>
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <v-form @submit.prevent="onSubmit" ref="form" lazy-validation>
            <v-card-text>
              <ValidationProvider
                name="Name"
                rules="required|email"
                v-slot="{ errors, valid }">
                <v-text-field
                  type="text"
                  label="Digite aqui o seu email"
                  name="email"
                  prepend-icon="person"
                  required
                  v-model="email"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              <ValidationProvider
                name="Senha"
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  type="password"
                  label="Senha"
                  name="password"
                  prepend-icon="lock"
                  required
                  v-model="password"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              Ainda não é cadastrado?
              <router-link :to="{ name: 'cadastro' }"
                >Cadastre-se aqui.</router-link
              >
              <br />
              Esqueceu a senha?
              <router-link :to="{ name: 'esqueci' }"
                >Recupere-a aqui.</router-link
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                type="submit"
                color="primary"
                block
                large
                :loading="loading"
                :disabled="invalid"
                >Entrar</v-btn
              >
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </template>
  </v-pagina-de-apresentacao>
</template>

<script>
import { mapState, mapActions } from "vuex"
import VPaginaDeApresentacao from "@/layouts/PaginaDeApresentacao"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import messageMixin from "@/mixins/translateMessageMixin"

const LOGIN_INVALIDO = "Login e/ou senha inválidos."
const SESSAO_EXPIRADA = "Sua sessão expirou. Faça login novamente."
const EMAIL_CONFIRMADO = "Email confirmado com sucesso."

export default {
  components: { ValidationObserver, ValidationProvider, VPaginaDeApresentacao },
  props: ["to", "invalidToken"],
  mixins: [messageMixin],
  data: () => ({
    loading: false,
    email: "",
    password: "",
    error: "",
  }),
  created() {
    if (this.invalidToken) {
      this.showErro(SESSAO_EXPIRADA)
    }
    if (this.$route.query && this.$route.query.confirmado) {
      this.showSucesso(EMAIL_CONFIRMADO)
    }
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch("auth/login", {
            email: this.email,
            password: this.password,
          })
          .then(() => {
            if (this.$store.getters["auth/isPrefeitura"]) {
              this.$router.push("/salas")
            } else if (this.$store.getters["auth/isAuthenticated"]) {
              this.$router.push("/")
            }
          })
          .catch((e) => {
            if (e.response.status === 400) {
              if (
                e.response.data.error.message ==
                "Your account email is not confirmed"
              ) {
                this.showErro(
                  "Sua conta não foi confirmada. Por favor, verificar o seu email."
                )
              } else {
                this.showErro(LOGIN_INVALIDO)
              }
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
    }),
  },
}
</script>
